import React, { useEffect, useMemo, useState } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import QRCode from 'qrcode.react';
import api from '../../services/api';

import whatsappIcon from '../../assets/whatsapp.png';

import './styles.css';

function PedidoPix() {
    const [cliente, setCliente] = useState({});
    const [copied, setCopied] = useState(false);
    const orderData = useMemo(() => {
        try {
            return JSON.parse(sessionStorage.getItem('last_order_data') || '{}');
        } catch (error) {
            return {};
        }
    }, []);

    useEffect(() => {
        let link = '';
        if(window.location.href.includes('https')){
          link = window.location.href.split('https://')[1];
        } else{
          link = window.location.href.split('http://')[1]; 
        }

        api.get('clientes/'+link.split('.')[0]).then(response =>{
            setCliente(response.data[0]);
        });
    }, []);

    function handleCopyPixButton() {
        const pixCopyPaste = orderData?.pix?.copia_cola;
        if (!pixCopyPaste) return;

        navigator.clipboard.writeText(pixCopyPaste).then(() => {
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1800);
        });
    }

    function handleWhatsappButton() {
        const phoneNumber = String(cliente.whatsapp || '').replace(/\D/g, '');
        const message = window.encodeURIComponent(`Olá ${cliente.nome_empresa}! Me chamo ${orderData.nome || ''} e gostaria de confirmar meu pedido.`);
        window.open(`https://wa.me/55${phoneNumber}?text=${message}`, '_blank', 'noopener,noreferrer');
    }

    return (
        <div id="order_complete_container">
            <header>
                <Link to="/">
                    Voltar ao menu
                    <FiChevronRight size={16}></FiChevronRight>
                </Link>
            </header>
            <main>
                <h1>Obrigado pelo seu pedido!</h1>
                <p>Faça o pagamento via PIX.</p>

                <div className="line" />

                <div className="field">
                    <h3>Valor do Pedido</h3>

                    <span>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(orderData.totalValue || 0)}</span>
                </div>

                {orderData?.pix?.copia_cola && (
                    <>
                        <div className="pix_qr_code">
                            <QRCode value={orderData.pix.copia_cola} size={220} includeMargin />
                        </div>

                        <div className="pix_copy_paste" onClick={handleCopyPixButton} role="button" tabIndex={0}>
                            <span>{orderData.pix.copia_cola}</span>
                            <button type="button" aria-label="Copiar código Pix">Copiar</button>
                        </div>
                        {copied && <span className="copy_pix_balloon">Copiado!</span>}
                    </>
                )}

                <h2>Já efetuou o pagamento?</h2>
                <p>Envie-nos o comprovante</p>

                <button className="whatsapp_button" onClick={handleWhatsappButton}>
                    Enviar comprovante
                    <img src={whatsappIcon} alt="Whatsapp" />
                </button>
            </main>
        </div>
    );
}

export default PedidoPix;
